import React, {useEffect} from 'react';
import { useQuery } from '@apollo/react-hooks';
import _ from 'lodash';

import ItemPreview from './ItemPreview';
import { ALL_ITEMS_QUERY } from '../services/graphql';
/*import MainLoader from '../../Shared/MainLoader';*/
import { sortItems } from '../../../services/utils/boomer';
import Coins from '../../Dashboard/images/gem.svg';

const Items = ({ inventoryType, onSelectItem, ownedItems, selectedCategory, wearing, setAllItems }) => {
    const { data, error, loading } = useQuery(ALL_ITEMS_QUERY);
    
    useEffect(() => {
        if (data) {
            setAllItems(data.avatarItems)
        }
    }, [data, setAllItems])

    if (error) {
        return <p>{error.message}</p>
    }
    if (loading) {
        return <p>Loading</p>
    }
    if (data && data.avatarItems) {
        const catalogItems = inventoryType === 'owned' ?
            _.uniqBy([...data.avatarItems, ...ownedItems], item => String(item.id)) :
            data.avatarItems;
        const allItems = sortItems(wearing, ownedItems, catalogItems);
        const itemType = selectedCategory;
        const categoryItems = _.filter(allItems, ['type', itemType]);
        const items = inventoryType === 'owned' ?
            _.filter(categoryItems, item => item.owned || item.price === 0) :
            categoryItems;

        if (items.length > 0) {
            return _.map(items, item => {
                const itemName = item.name || `${item.type === 'body' ? 'Skin' : _.startCase(item.type)} ${item.id}`;
                const showStatus = item.owned || item.price !== 0;

                return (
                    <li
                        key={`item-${selectedCategory}-${item.id}`}
                        onClick={() => onSelectItem(item)}
                        className={`store__item ${item.wearing ? 'store__item--wearing' : ''}`}
                    >
                        <p className="store__item-name">{itemName}</p>
                        {item.type === 'backdrop' ? <img src={item.url[0]} className="store__backdrop-thumbnail" alt="Backdrop" /> : <ItemPreview src={item.url[0]} className="store__item-img" />}
                        {item.wearing ?
                            <span className="store__item-selected" aria-label="Equipped">✓</span> :
                            <span className="store__item-selected" aria-hidden="true"></span>
                        }
                        {showStatus &&
                            <p className={`store__item-status ${item.owned ? 'store__item-status--owned' : ''}`}>
                                {item.owned ?
                                    <><span aria-hidden="true">✓</span> Owned</> :
                                    <><img src={Coins} alt="Gems" /> {item.price}</>
                                }
                            </p>
                        }
                    </li>
                )
            });
        }
        if (inventoryType === 'owned') {
            return <li className="store__no-item">You do not own any items in this category.</li>
        }
    }
    return null;
}

export default Items;
